const news = [
  {
    id: 1,
    title: 'Церемония награждения участников Turbo Racing Cup',
    content: "30 марта состоялась церемония награждения участников Всероссийского Чемпионата по шоссейно-кольцевым гонкам \"Turbo Racing Cup\".<br><br> По итогам года Серебряным призером в классе Super Sport PRO стал пилот нашей команды Ярослав Гужев. На церемонии за него получала призы и награды пилот и менеджер команды Ксения Богданова.<br><br> Все! Все награды за прошедший сезон собраны, двигаемся дальше!",
    date: '30 марта 2025',
    img: 1
  },
  {
    id: 2,
    title: 'Новости и календарь сезона 2025',
    content: 'Дорогие друзья осталось совсем немного времени до старта нового гоночного сезона. Уже 20 апреля вы сможете снова встретиться с нами на автодроме MoscowRaceway на первом этапе сезона, который в этом году стартует с легендарного чемпионата MaxPowerCars. Полный календарь вы сможете увидеть ниже на сайте. И в этом году в нем добавился совершенно новый автодром - Sokol International Circuit Казахстан г. Алматы<br> До встречи на треках!',
    date: '20 марта 2025',
    img: 2,
  },
  {
    id: 3,
    title: 'Итоги 2024 года — два серебряных призера!',
    content: 'По итогам года Всероссийского чемпионата по шоссейно-кольцевым гонкам RHHCC RTAC, состоящего из  пяти этапов проходивших в четырех городах России - серебряными призерами в классах Hot Track и Hot Race стали пилоты команды VirgaRacing Гужев Ярослав и Гонтюрев Сергей!',
    date: '20 ноября 2024',
    img: 3,
  },
]


$(function() {

    const prevArrow = $(".js-topical-prev-btn");
    const nextArrow = $(".js-topical-next-btn"); 

    $('.js-topical-slider').slick({
        slidesToShow: 3,
        arrows: true,
        dots: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow,       

        responsive: [            
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
    // $(document).ready(function() {
      
    //   function generateModalContent(item) {

    //     return `<div class="news-modal__body">
    //     <div class="news-modal__content-left">
    //         <img src="img/content/news/${item.img}.png" alt="news" class="news-modal__img" />
    //     </div>
    //     <div class="news-modal__content-right">
    //         <p class="news-modal__date">${item.date}</p>
    //         <p class="news-modal__caption">${item.title}</p>
    //         <p class="news-modal__text">${item.content}</p>
    //     </div>
    // </div>`
    //   }
    //   $('.topical__item').on("click", function () {
    //     const id = $(this).data("id");
    //     const item = news.find(i => i.id === id);

    //     $("#modal-body").html(generateModalContent(item));
    //     $("#modal").fadeIn();
    //   });
    //   $(".close, #modal").on("click", function (e) {
    //     if (e.target !== this) return;
    //     $("#modal").fadeOut();
    //   });

   
    // });
})
